<template>
   <svg xmlns="http://www.w3.org/2000/svg" v-bind="$props" :class="classes" viewBox="0 0 16 16" >
      <path fill-rule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
   </svg>
</template>

<script>
export default {
   name: "info-icon-atom",
   props: {
      color: {
         type: String,
         default: 'light',
         validator: value => [ "primary","secondary","success","info","light","dark","danger", ].includes(value),
      },
      size: {
         type: String,
         default: 'medium',
         validator: value => [ "x-small","small", "medium", "large","x-large"].includes(value),
      }
   },
   computed: {
      classes()
      {
         return {
            [`${this.size}`] : true,
            [`${this.color}`]: true,
            'info-icon': true,
         };
      },
   }
}
</script>

<style lang="scss" scoped>
.info-icon {
   @include setIconSizeClasses();
   @include setIconColorClasses();
}
</style>